import { createContext, type ReactNode, useContext } from 'react';

interface MentionContextType {
  getPrefix?: (id: string, label: string) => ReactNode | null;
}

export const MentionContext = createContext<MentionContextType>({});

export const useMentionContext = () => useContext(MentionContext);
